import React, { useMemo } from 'react';
import { Popover, Typography, Space } from 'antd';

/**
 * @description table-cell内展示多个元素的方案 < 接受自行决定要不要拓展到其他应用场景 >
 * @param:
 *    - sourceList 需要展示的数据源 【interface: < { txt:string, [key:string]:any } >[]】【txt：单个展示内容值】
 *    - layout 布局方式【 block:元素单独一行一行展示，inline:混在一起用逗号隔开】【默认 "block"】
 *    - maxShowNum 最大显示几个 【最大显示几个，超出给予更多】【默认 1】
 */
/* *************** 前置维度一些默认值 **************** */
/* innerPopoverStyle */
const innerPopoverStyle = {
  borderRadius: '4px',
  maxHeight: '300px',
  overflow: 'hidden auto',
};

/* ********************* 输出 ******************** */
export default function ShowMorePopList({ sourceList, layout = 'block', maxShowNum = 1 }) {
  if (!(sourceList && Array.isArray(sourceList) && sourceList.length > 0)) return <span>-</span>;

  const computedPreShowList =
    maxShowNum >= 1 ? (sourceList?.length > maxShowNum ? sourceList?.slice(0, maxShowNum) : sourceList) : sourceList;
  const computedPreShowListLen = computedPreShowList.length;

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        alignItems: 'flex-start',
      }}
    >
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'flex-start',
          alignItems: 'flex-start',
        }}
      >
        {layout === 'inline'
          ? computedPreShowList?.reduce((total, item, index) => {
              return total + (item?.txt || '') + (index === computedPreShowListLen - 1 ? '' : `、`);
            }, '')
          : computedPreShowList?.map((item, index) => <ShowItemTxt showTxt={item?.txt || ''} key={index} />)}
      </div>
      {/* 数据源大于显示的限定值给予显示 */}
      {sourceList.length > maxShowNum ? (
        <Popover
          color="#000000d9"
          overlayInnerStyle={innerPopoverStyle}
          placement="bottom"
          trigger="hover"
          content={() => popoverContent(sourceList)}
        >
          <Typography.Link style={{ margin: '0 auto' }}>更多</Typography.Link>
        </Popover>
      ) : null}
    </div>
  );
}

/**
 * popoverContent
 * 可以考虑immutable缓存
 */
function popoverContent(sourceList) {
  return (
    <>
      {sourceList && Array.isArray(sourceList) && sourceList.length > 0
        ? sourceList.map((item, index) => {
            return <ShowItemTxt showTxt={item?.txt || ''} key={index} inPopContent={true} />;
          })
        : null}
    </>
  );
}

/**
 * 缓存单个组件
 * showTxt 单个文案
 * inPopContent 是否pop内
 */
function ShowItemTxt({ showTxt, inPopContent = false }) {
  const MemoizedShowTxt = useMemo(
    () => (
      <Space size={4} style={inPopContent ? { color: '#fff', display: 'flex' } : {}}>
        <span>{showTxt || ''}</span>
      </Space>
    ),
    [showTxt, inPopContent]
  );
  return <>{MemoizedShowTxt}</>;
}
